"use client";

import React, { useState } from "react";
import LifestylePop from "../components/lifestyle-pop/lifestyle-pop.jsx";
import TextComponent from "../components/text/text.jsx";
import Slideshow from "../components/slideshow/slideshow.jsx";
import Download from "../components/download/download.jsx";
import ComparisonCards from "../components/comparison-cards/comparison-cards.jsx";
import UpgradeToday from "../components/upgrade-today/upgrade.jsx";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import { openSAResortsSSO } from "../utils/obBookingUtils";

const OffBeatHolidayClub = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogin = () => {
    window.location.href = "/?p=login";
  };

  const getOBBookingLink = async (endpoint) => {
    if (endpoint === "/offbeatresorts") {
      openSAResortsSSO(setOpen);
    }
  };

  const slideData = [
    {
      title: "Off Beat membership & Benefits",
      description: "",
      buttonLabel: "",
      buttonLink: "",
      imageUrl:
        "https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/Benefits%20Web.png",
      mobileImageUrl:
        "https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/Benefits%20Mobile.png",
      h2col: "#f08f1f",
    },
  ];

  const options = {
    // Customize Flickity options here
    cellAlign: "left",
    contain: true,
    freeScroll: true,
    wrapAround: true,
    adaptiveHeight: true,
    autoPlay: 4000,
    prevNextButtons: false,
  };
  return (
    <div>
      <Slideshow banners={slideData} options={options} />
      <TextComponent header="Benefits" content="" />
      <LifestylePop
        backgroundImage="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/off-beat-benefits/Benefits-01.png"
        title="SA Resorts"
        subtext="<p>With Off Beat Holiday Club you have access to 45+ South African resorts at the lowest prices available. Enjoy a vast selection of resorts from beach holidays and city breaks to berg and bush breaks for the adventure seekers.</p>"
        popUpContent="<div className='pop-up-inner'>
            <p>
            <b>We promised you that as a Off Beat Plus member, you'd get to live your
            BEST life for LESS! It's time to deliver!</b><br></br>
        
        <b>Off Beat Plus members qualify for the following 3 AWESOME BENEFITS ...
        because we love you THAT much!</b><br></br>
        
        <b>How it Works</b><br></br>
        
        <b>Benefit #1 - Dining Cashback</b><br></br>
        
        Off Beat Plus members get up to R120 CASHBACK on their second most expensive
        meal at over 2,000 selected Crave Dining Cashback restaurants countrywide. In
        addition to sit-down, you ALSO get Dining Cashback benefits at listed Cashback
        restaurants on takeaway and delivery (in-house, Mr D, Uber Eats, Order In, etc.) orders!<br></br>
        
        Simply purchase a minimum of 2 meals and 2 drinks to be eligible for your cashback
        benefit! Basically, we're saving you money on the things you already love doing!<br>
        #Winning<br></br>
        
        Feeling hungry yet?<br></br>
        
        Find a restaurant close to you by downloading and checking your app ... and start
        using your benefits today!<br></br>
        
        <b>Benefit #2 - Dining Voucher</b><br></br>
        
        Eat out at diverse and exciting restaurants around the country without breaking the
        bank! Off Beat Plus members enjoy a R120 DISCOUNT on meals at participating
        restaurants countrywide when they spend R300 or more. Discounts are redeemed by
        using Zapper. In addition to sit-down, you ALSO get takeaway and delivery (in-house)
        service on the Dining Voucher benefit at listed restaurants.<br></br>
        
        Provided that Zapper was installed by the 15th of the month, your Crave Dining Benefit
        Voucher will be sent to you on the 1st of the month after your benefit is activated.
        Your voucher will appear under “My vouchers” which can be accessed via the green
        Vouchers section of your Zapper app. Your voucher will be automatically selected
        when you purchase at participating partners.<br></br>
        
        Feel like eating out?<br>
        Find a restaurant close to you by downloading and checking your app ... and start
        using your benefits today!<br></br>
        
        <b>Benefit #3 - Coffee Voucher</b><br></br>
        
        For the lovers of coffee - let's get two-gether! Off Beat Plus members get a FREE
        COFFEE with every coffee they purchase at participating coffee shops countrywide!
        (Minimum spend of R30; maximum discount of R25) Discounts are redeemed at
        participating restaurants by using Zapper. In addition to sit-down, you ALSO get
        takeaway coffees on the Coffee Voucher benefit at listed restaurants.<br></br>
        
        Provided that Zapper was installed by the 15th of the month, your Crave Coffee Benefit
        Voucher will be sent to you on the 1st of the month after your benefit is activated.
        Your voucher will appear under “My vouchers” which can be accessed via the green
        Vouchers section of your Zapper app. Your voucher will be automatically selected
        when you purchase at participating partners.<br></br>
        
        Keen for a coffee?<br>
        Find a coffee shop close to you by downloading and checking your app ... and start
        living your BEST life today!<br></br>
        
        Zapper is a mobile app that allows you to pay your bill by simply scanning the QR code
        with your smartphone.<br></br>
        
        *Ts & Cs Apply. E & OE.</p>
        </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Explore",
          link: "/",
          ssoLink: "/offbeatresorts",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Click to call",
          link: "https://examplelink2.com",
          visibility: true,
          popup: false,
        }}
        button3={{ text: "", link: "", visibility: false, popup: false }}
        contentAlign="right"
        popUpImage="/images/Dining_PopUp.jpg"
        but2transform="none"
        getOBBookingLink={getOBBookingLink}
      />
      <LifestylePop
        backgroundImage="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/off-beat-benefits/Benefits-02.png"
        title="International Exchanges"
        subtext="<p>International destinations are booked through the club's exchange agreement with RCI,
        for ultimate value & unforgettable, hassle-free holidays.<br><br>
        
        Call us on +27 (0)31 717 7592 or email internationalres@holidaygateway.co.za and
        we'll help you find a great holiday anywhere around the world!</p>"
        popUpContent="<div>
            <h4>With Off Beat Plus you can enjoy the latest blockbuster releases at any selected movie theatre and SAVE!</h4><br>
            <p>
            <b>Mad about movies? Enjoy amazing discounts on movie tickets at Ster-Kinekor, Nu Metro and CineCentre cinemas, as well as cooldrink and popcorn combos at Ster-Kinekor and Nu Metro cinemas.</b><br>
            <ul>
                <li>Up to 50% off 3D movie tickets at Ster-Kinekor, Nu Metro and CineCentre – 2 per
                month</li>
                <li>Up to 50% off 2D movie tickets at Ster-Kinekor, Nu Metro and CineCentre – 2 per
                month</li>
                <li>Up to 50% off regular cooldrink and popcorn combos at Ster-Kinekor and Nu Metro
                – 4 per month</li>
            </ul><br>
            <p><b>How it Works</b></p><br>
            <ul>
                <li>Click to <a href='https://apps.apple.com/za/app/off-beat-plus/id1500726431'><u>DOWNLOAD</u></a> Off Beat Plus app</li>
                <li>Select your deal</li>
                <li>Make payment online</li>
                <li>Receive your SMS with your voucher</li>
                <li>Show the teller at the cinema your voucher OR enter your code at the self-service
                terminal and print your tickets</li>
                <li>Vouchers are valid for 3 years</li>
            </ul>
            </p>
            </div>"
        logo1={{
          alt: "",
          src: "",
          visibility: false,
        }}
        logo2={{
          alt: "",
          src: "",
          visibility: false,
        }}
        logo3={{
          alt: "",
          src: "",
          visibility: false,
        }}
        button1={{
          text: "Click to Call",
          link: "https://examplelink2.com",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Click to email",
          link: "https://examplelink2.com",
          visibility: true,
          popup: false,
        }}
        button3={{ text: "", link: "", visibility: false, popup: false }}
        but2transform="none"
        contentAlign="left"
        popUpImage="/images/Movies_PopUp.jpg"
      />
      <LifestylePop
        backgroundImage="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/off-beat-benefits/10763_Clubs_Website_Msc%20Armonia_obhc.jpg"
        title="MSC Armonia"
        subtext="<p>Open waters, sunlit decks, indulgent dining and unforgettable experiences at sea, all with exclusive member rates<br><br>
        
        The MSC Armonia arrives in South Africa from 27 November 2026 for her maiden local season.<br><br>

        Bookings are now open and cabins are limited.<br><br>
        
       Call 031 717 7592 to secure your cabin.</p>"
        popUpContent="<div>
            <h4>Our Spa Benefit</h4><br>
            <p><b>Relax and Rejuvenate at any of 20 La Vita Spas countrywide. Get 20% off
            all standard price treatments. PLUS members enjoy 1 full body massage
            voucher absolutely free every 12 months.</b><br></br>
            
            <b>Choose from 4 treatments:</b><br>
            <ul>
            <li><b>Roman Royalty Swedish Massage (50 min)</b></li>
            <li><b>De-stress Back and Foot Massage (50 min)</b></li>
            <li><b>Full Body Exfoliation (50 min)</b></li>
            <li><b>Hands & Feet Deluxe (50 min)</b></li>
            </ul><br></br>
            
            <b>How it Works</b><br></br>
            
            <ul>
            <li>To enjoy these amazing spa benefits, download the app to find a spa closest to you, select the spa and to request your 20% off voucher.</li>
            <li>Call the spa of your choice to book your appointment, present your voucher from the app (in My Cashback Rewards) on arrival at the spa and enjoy your discounted spa privilege.</li>
            <li>PLUS check the app regularly to redeem your complimentary full body massage (one every 12 months)</li>
            </ul>
            </p>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Click to Call",
          link: "tel:+27317177592",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Itinerary",
          link: "https://fgcdn.azureedge.net/cope/CRUISE_Itineraries/MSC-ARMONIA-ITINERARY_2026-2027.pdf",
          visibility: true,
          popup: false,
        }}
        button3={{ text: "", link: "", visibility: false, popup: false }}
        but2transform="none"
        contentAlign="right"
        popUpImage="/images/Spa_PopUp.png"
      />
      <TextComponent
        header="How it works"
        content="The Off Beat Holiday Club acquires sought-after holiday weeks in self-catering timeshare resorts throughout the country. Members may make use of
this accommodation simply by paying the Accommodation Fees for the relevant week/s in the resort of their choice.<br><br>

The accommodation comprises of luxury chalets and apartments. A limited number of hotels are also available, but meals are not included in the
Accommodation Fees.<br><br>

The accommodation is reserved for the exclusive use of the Off Beat member and his immediate family specific to the size of the unit booked.<br><br>

Members will be allowed to book either a weekend (3 nights) midweek (4 nights), or Full Week (7 nights), depending on availability and the Resort's
Policy.<br><br>

Special offers are regularly advertised, whereby members may take advantage of discounted rates on selected accommodation.<br><br>"
      />
      <TextComponent
        header="Becoming a member"
        content="All members of the SAPS, retired members and civilians on the payroll of the SAPS, are eligible for membership of Off Beat Holiday Club. You may
join the Club by requesting the relevant stop order form from our Admin office on +27 (012) 349 1433.<br><br>

Alternatively, <a href='https://fgcdn.azureedge.net/cope/Member_Documents/OffbeatHC%20Stop%20Order%20R40.pdf' target='_blank'>click here</a> to download the form and fax to +27 (012) 349 2159 or email to  <a href='mailto:charity@offbeat.co.za'>charity@offbeat.co.za</a> once completed.<br><br>

As soon as your stop order form has been received and activated on your salary, you immediately become a member of Off Beat Holiday Club. Your
service number will be used as your membership number for Off Beat Holiday Club.<br><br>"
        // image={"/images/8502_OBHC_Transact Online Banner_V1-01.png"}
      />
      <ComparisonCards />
      <UpgradeToday />
      <Download />

      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{ height: "200px !important" }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            You are not logged in. Please login to proceed.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleLogin}>Proceed to Login</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OffBeatHolidayClub;
